import { Component, OnInit } from '@angular/core';
import { PartnersConst } from './const';
import { PartnersModel } from './partners.model';
import { PartnersService } from './partners.service';
import { PartnersDialogDeleteComponent } from './partners-dialog-delete.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../../shared/dummy.component';
import { Router } from '@angular/router';
import { PartnersFormComponent } from './partners-form.component';
import { PartnersFormTransactionsComponent } from './partners-form-transactions.component';
import { consts } from '../../../../consts';
import { Utils } from '../../../../shared/utils';
import { AccountingAccountsModel } from '../../../accounting/accounting-accounts/accounting-accounts.model';
import { AccountingAccountsService } from '../../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsDialogLedgerComponent } from '../../../accounting/accounting-accounts/accounting-accounts-dialog-ledger.component';

@Component({
    selector: 'app-partners-list',
    templateUrl: './partners-list.component.html',
    styleUrls: ['./partners-list.component.css'],
    standalone: false
})
export class PartnersListComponent implements OnInit {

  ready = false;
  empty: boolean = true;
  headerTable: any[] = PartnersConst.headerTable;
  dataSource: PartnersModel[] = [];

  constructor(
    public partnersService: PartnersService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    private router: Router,
    protected snackBar: MatSnackBar,
    private accountingAccountsService: AccountingAccountsService,
  ) { }

  public ngOnInit() {
    this.partnersService.getList().then(
      data => {
        this.dataSource = data;
        this.ready = true;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      });
  }

  public create(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(PartnersFormComponent, {
      width: '620px', maxWidth: '96vw',
      data: { uid: uid },
    })
      .afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.dummy.redirectTo(this.router.url);
        }
      });
  }

  public edit(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(PartnersFormComponent, {
      width: '620px', maxWidth: '96vw',
      data: { uid: uid },
    })
      .afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.dummy.redirectTo(this.router.url);
        }
      });
  }

  public delete(uid: number) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(PartnersDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      });
  }

  public contribution(uid: number, isContribution: boolean): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const PartnerSelected = this.dataSource.find(x => x.uid === uid);
    this.dialog.open(PartnersFormTransactionsComponent, {
      // height: '50%',
      // width: '50%',
      data: { uid: uid, isContribution: isContribution, PartnerSelected: PartnerSelected },
    })
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public mayor_551(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    let accountingModelsResponse: AccountingAccountsModel[] = [];
    let accountingModels: AccountingAccountsModel =
      new AccountingAccountsModel();

    this.accountingAccountsService
      .list(0, 1, searchedElement.accountingModels551)
      .subscribe((x: any) => {
        accountingModelsResponse = x.data;

        if (accountingModelsResponse && accountingModelsResponse.length === 1) {
          accountingModels = accountingModelsResponse[0];
          accountingModels = accountingModelsResponse[0];
        }

        this.dialog.open(AccountingAccountsDialogLedgerComponent, {
          width: '700px',
          maxWidth: '96vw',
          
          maxHeight: '90vh',
          autoFocus: false,
          data: {
            id: accountingModels.id,
            name: accountingModels.name,
            number: accountingModels.number,
          },
        });
      });
  }

  public mayor_118(uid: number): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    let accountingModelsResponse: AccountingAccountsModel[] = [];
    let accountingModels: AccountingAccountsModel =
      new AccountingAccountsModel();

    this.accountingAccountsService
      .list(0, 1, searchedElement.accountingModels118)
      .subscribe((x: any) => {
        accountingModelsResponse = x.data;

        if (accountingModelsResponse && accountingModelsResponse.length === 1) {
          accountingModels = accountingModelsResponse[0];
          accountingModels = accountingModelsResponse[0];
        }

        this.dialog.open(AccountingAccountsDialogLedgerComponent, {
          width: '700px',
          maxWidth: '96vw',
          
          maxHeight: '90vh',
          autoFocus: false,
          data: {
            id: accountingModels.id,
            name: accountingModels.name,
            number: accountingModels.number,
          },
        });
      });
  }

}
